export const voicings = {
    Cmaj7: ["C3", "G3", "B3", "E4"],
    Cm7: ["C3", "G3", "Bb3", "Eb4"],
    C7: ["C3", "Bb3", "E4", "A4"],
    Cm7b5: ["C3", "Bb3", "Eb4", "Gb4"],

    Dbmaj7: ["Db3", "Ab3", "C4", "F4"],
    Dbm7: ["Db3", "B3", "Eb4", "E4"],
    Db7: ["Db3", "B3", "Eb4", "G4"],
    Dbm7b5: ["Db2", "F3", "B3", "Eb4", "G4"],

    Dmaj7: ["D3", "A3", "C#4", "F#4"],
    Dm7: ["D3", "A3", "C4", "E4", "F4"],
    D7: ["D3", "F#3", "C4", "Eb4", "Bb4"],
    Dm7b5: ["D3", "Ab3", "C4", "F4"],

    Ebmaj7: ["Eb2", "Bb2", "G3", "D4"],
    Ebm7: ["Eb2", "Gb3", "Bb3", "Db4", "F4"],
    Eb7: ["Eb2", "Gb3", "Db4", "E4"],
    Ebm7b5: ["Eb2", "Gb3", "A3", "Db4"],

    Emaj7: ["E3", "B3", "D#4", "G#4"],
    Em7: ["E2", "G3", "B3", "D4"],
    E7: ["E2", "D3", "G#3", "F4"],
    Em7b5: ["E2", "G3", "Bb3", "D4"],

    Fmaj7: ["F2", "E3", "A3", "C4", "E4"],
    Fm7: ["F2", "C3", "Ab3", "Eb4"],
    F7: ["F2", "Eb3", "A3", "D4"],
    Fm7b5: ["F2", "Eb3", "B3", "Ab4"],

    Gbmaj7: ["Gb2", "Bb3", "Db4", "F4"],
    Gbm7: ["Gb2", "E3", "A3", "C#4", "E4"],
    Gb7: ["Gb2", "E3", "Bb3", "Eb4"],
    Gbm7b5: ["Gb2", "E3", "A3", "C4", "E4"],

    Gmaj7: ["G2", "F#3", "G3", "B3", "D4"],
    Gm7: ["G2", "F3", "A3", "Bb3", "D4"],
    G7: ["G2", "F3", "B3", "E4", "Ab4"],
    Gm7b5: ["G2", "Bb3", "Db4", "F4"],
 
    Abmaj7: ["Ab2", "Eb3", "G3", "C4"],
    Abm7: ["Ab2", "Gb3", "B3", "Eb4"],
    Ab7: ["Ab2", "Gb3", "C4", "F4"],
    Abm7b5: ["Ab2", "Gb3", "B3", "D4", "Gb4"],

    Amaj7: ["A2", "E3", "G#3", "C#4"],
    Am7: ["A2", "G3", "B3", "C4", "E4"],
    A7: ["A2", "G3", "Bb3", "C#4", "F4"],
    Am7b5: ["A2", "G3", "C4", "Eb4", "G4"],

    Bbmaj7: ["Bb2", "F3", "A3", "D4", "F4"],
    Bbm7: ["Bb2", "Ab3", "C4", "Db4", "F4"],
    Bb7: ["Bb2", "Ab3", "D4", "G4", "B4"],
    Bbm7b5: ["Bb2", "Ab3", "Db4", "E4", "Ab4"],

    Bmaj7: ["Bb2", "A#3", "D#4", "F#4", "C#5"],
    Bm7: ["B2", "F#3", "A3", "D4", "F#4"],
    B7: ["B2", "A3", "D#4", "G#4"],
    Bm7b5: ["B2", "A3", "D4", "F4"],

}